import { LOAD_QUESTIONS, SELECT_QUESTION, CLEAN_SELECTED_QUESTION } from "../actions/actionTypes";

const initialState = {
    questions: [],
    selectedQuestion: null
};

export const questionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_QUESTIONS:
            return {
                ...state,
                questions: action.questions
            };
        case SELECT_QUESTION:
            return {
                ...state,
                selectedQuestion: action.question
            };
        case CLEAN_SELECTED_QUESTION:
            return {
                ...state,
                selectedQuestion: null
            }
        default:
            return state;
    }
};